const shareButtonsSelector = '[data-behavior="share-result"]';

const shareUrl = () => {
  const canonical = document.querySelector('link[rel="canonical"]');

  if (canonical && canonical.href) {
    return canonical.href;
  }

  return window.location.href;
};

const buttonLabel = (button) => button.querySelector('[data-share-label]');

const setLabel = (button, label) => {
  const labelElement = buttonLabel(button);

  if (labelElement && label) {
    labelElement.textContent = label;
  }
};

const restoreLabel = (button) => {
  window.setTimeout(() => setLabel(button, button.dataset.shareDefaultLabel), 2000);
};

const fallbackCopy = (text) => new Promise((resolve, reject) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '-1000px';
  textarea.style.left = '-1000px';
  document.body.appendChild(textarea);
  textarea.select();

  let copied = false;

  try {
    copied = document.execCommand('copy');
  } finally {
    document.body.removeChild(textarea);
  }

  if (copied) {
    resolve();
  } else {
    reject(new Error('copy failed'));
  }
});

const copyToClipboard = (text) => {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  }

  return fallbackCopy(text);
};

const copyAndMark = (button, url) => {
  copyToClipboard(url)
    .then(() => setLabel(button, button.dataset.shareCopiedLabel))
    .catch(() => setLabel(button, button.dataset.shareErrorLabel))
    .then(() => restoreLabel(button));
};

const handleShareClick = (event) => {
  const button = event.currentTarget;
  const url = shareUrl();
  const title = button.dataset.shareTitle || document.title;

  if (navigator.share) {
    navigator.share({ title, url }).catch((error) => {
      if (!error || error.name !== 'AbortError') {
        copyAndMark(button, url);
      }
    });
  } else {
    copyAndMark(button, url);
  }
};

export const initShareButtons = () => {
  document.querySelectorAll(shareButtonsSelector).forEach((button) => {
    if (button.dataset.shareReady) {
      return;
    }

    button.dataset.shareReady = 'true';
    button.addEventListener('click', handleShareClick);
  });
};
